var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.41 5.47 15.54C5.91 15.62 6.09 15.34 6.09 15.11C6.09 14.91 6.08 14.33 6.08 13.57C4 13.98 3.48 12.73 3.48 12.73C3.08 11.83 2.5 11.59 2.5 11.59C1.69 11.08 2.56 11.09 2.56 11.09C3.45 11.15 3.94 11.98 3.94 11.98C4.73 13.26 6.09 12.83 6.62 12.6C6.69 12.1 6.88 11.76 7.12 11.56C5.34 11.36 3.46 10.7 3.46 7.61C3.46 6.73 3.79 6.03 4.31 5.49C4.21 5.29 3.92 4.5 4.39 3.41C4.39 3.41 5.1 3.17 6.09 4.23C6.64 4.06 7.23 4 7.82 4C8.41 4 9 4.06 9.56 4.23C10.55 3.17 11.26 3.41 11.26 3.41C11.73 4.5 11.44 5.29 11.34 5.49C11.86 6.03 12.18 6.73 12.18 7.61C12.18 10.71 10.3 11.35 8.51 11.55C8.78 11.8 9.01 12.22 9.01 12.85C9.01 13.78 9 14.65 9 15.11C9 15.34 9.18 15.63 9.63 15.54C12.82 14.41 15.11 11.54 15.11 8C15.11 3.58 11.42 0 8 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.1a26dca7c398b074eab5f3e309d8160e.svg";
export { ForwardRef as ReactComponent };